<template>
  <div class="swiper-card card-unlock">
    <div class="unlock-inner" :class="[`mq-${$mq}`]">    
      <div class="intro">
        <svg class="mark" width="28" height="32" viewBox="0 0 28 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 4C16.7625 4 19 6.2375 19 9V12H9V9C9 6.2375 11.2375 4 14 4ZM5 9V12H4C1.79375 12 0 13.7938 0 16V28C0 30.2062 1.79375 32 4 32H24C26.2062 32 28 30.2062 28 28V16C28 13.7938 26.2062 12 24 12H23V9C23 4.03125 18.9688 0 14 0C9.03125 0 5 4.03125 5 9ZM16 20V24C16 25.1063 15.1063 26 14 26C12.8937 26 12 25.1063 12 24V20C12 18.8937 12.8937 18 14 18C15.1063 18 16 18.8937 16 20Z" fill="black"/>
        </svg>

        <h3 v-if="$route.query.intro">Unlocking channels - let's break it down.</h3>
        <h3 v-else>Uh oh, it looks like this stack is locked.</h3>

        <h4 v-if="$route.query.intro">There are 3 simple ways to unlock channels — no secret codes or magic spells required.</h4>
        <h4 v-else>But have no fear, there are 3 ways to unlock this stack!</h4>
      </div>

      <div class="options">
        <div class="option">
          <span class="count">1</span>
          <div class="option-content">
            <div class="inner-content">
              <h4>Invite your friends</h4>
              <p>Unlock 5 channels for free: Invite your friends.</p>
            </div>
            <button @click="routeTo('invite')">Invite friends</button>
          </div>
        </div>

        <div class="option">
          <span class="count">2</span>
          <div class="option-content">
            <div class="inner-content">
              <h4>Complete your news detox</h4>
              <p>Unlock 3 channels for free: Just read each day.</p>
            </div>
            <button @click="routeTo('read')">Start reading</button>
          </div>
        </div>

        <div class="option">
          <span class="count">3</span>
          <div class="option-content">
            <div class="inner-content">
              <h4>Go Pro</h4>
              <p>Unlock all channels + support our mission.</p>
            </div>
            <button class="pro" @click="goPro()">Go Pro</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      slide: {
        type: Object,
      },
    },

    data() {
      return {
        visible: false,
        visibleBackground: false,
        isWorking: false,
      }
    },

    computed: {
      getAccount() {
        return this.$store.getters.getAccount;
      },
    },

    methods: {
      routeTo(type) {
        switch (type) {
          case 'invite':
            this.$router.push(`/~${this.getAccount.screen_name}/invite`);
            return;
          case 'read':
            this.$router.push(`/`);
            return;
          // case 'pro':
          //   this.$router.push(`/n/pro`);
          //   return;
          default: return;
        }
      },

      goPro() {
        this.EventBus.$emit("didSelectSubscribe", {
          didSelect: 'true' 
        });
      }
    },

    watch: {
      '$route.params.stack': {
        handler(slug) {
          if (slug === this.slide.slug) {
            this.$emit('swiperUpdate')
          }
        },
        immediate: true,
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .card-unlock {
    padding-top: calc(env(safe-area-inset-top) + 4rem);
    padding-bottom: calc(env(safe-area-inset-bottom) + 2rem);
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    min-height: 100vh;
    margin: auto;
    background: $neutral-600;
    color: $neutral-100;

    .darkmode & {
      background: $neutral-100;
      color: $neutral-600;
    }

    .unlock-inner {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      max-width: 600px;
      margin: 0 auto;

      .intro {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;

        .mark {
          margin-bottom: 1.5rem;
          path {
            fill: $green-tone-3;
          }
        }

        h3 {
          font-family: 'Brawler';
          font-weight: normal;
          line-height: 135%;
          font-size: 1.8rem;
        }

        h4 {
          font-family: 'Brawler';
          font-weight: normal;
          line-height: 135%;
          font-size: 1.4rem;
          margin-top: 0.5rem;
        }

        p {
          font-size: 0.95rem;
        }
      }

      .options {
        display: flex;
        flex-direction: column;
        margin-top: 3rem;
        gap: 1rem;

        .option {
          display: flex;
          align-items: center;
          position: relative;
          border: 2px dotted rgba($neutral-400, 0.25);
          border-radius: 15px;
          margin-left: 1rem;

          .count {
            width: 3rem;
            height: 3rem;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            left: -1.5rem;
            border-radius: 500px;
            border: 2px dotted rgba($neutral-400, 0.25);
            background: $neutral-600;

            .darkmode & {
              background: $neutral-100;
            }
          }

          .option-content {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            padding: 1rem 1rem 1rem 2.5rem;
            gap: 1rem;

            .inner-content {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
            }

            h3 {
              font-size: 1.2rem;
            }

            p {
              font-size: 0.9rem;
              margin-top: 0.5rem;
            }

            button {
              white-space: nowrap;

              &.pro {
                background: $green-tone-3;
                color: $neutral-600;
              }
            }
          }
        }
      }
    }
  }
</style>